import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Footer from "../common/components/footer/Footer";
import Navbar from "../common/components/navbar/Navbar";
import FloatingSocialWidget from "../common/components/widget/FloatingSocialWidget";
import AboutPage from "../pages/about/AboutPage";
import ContactPage from "../pages/contact/ContactPage";
import ContactSection from "../pages/contact/components/ContactSection";
import FAQPage from "../pages/faq/FaqPage";
import HomePage from "../pages/home/HomePage";
import ProjectPage from "../pages/projects/ProjectPage";
import ServicePage from "../pages/service/ServicePage";
import ScrollToTop from "./functions/ScrollToTop";

function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <FloatingSocialWidget />
      <div style={{ height: "70px" }} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectPage />} />
        <Route path="/faqs" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ContactSection />
      <Footer />
    </BrowserRouter>
  );
}

export default Router;
